import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { colors, fonts } from "../theme";
import { View, Text, Card, Button, Press, ScreenHeader, EmptyState } from "../ui";
import { Icon } from "../Icon";
import { useI18n } from "../i18n";
import { useAppState } from "../state";

export default function Notes() {
  const navigate = useNavigate();
  const { tr, lang } = useI18n();
  const { state, addNote, deleteNote } = useAppState();
  const [text, setText] = useState("");
  const add = () => { if (text.trim()) { addNote(text.trim()); setText(""); } };

  return (
    <View style={{ flex: 1, minHeight: "100vh", backgroundColor: colors.surfaceSecondary }}>
      <ScreenHeader title={tr("notes")} onBack={() => navigate(-1)} />
      <View style={{ padding: 20 }}>
        <Card style={{ marginBottom: 20 }}>
          <textarea
            data-testid="note-input"
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder={tr("addNote")}
            rows={3}
            style={{ border: "none", resize: "none", fontSize: 15, fontWeight: fonts.medium, color: colors.onSurface, width: "100%", background: "transparent" }}
          />
          <View style={{ marginTop: 12 }}>
            <Button testID="note-add" title={tr("addNote")} icon="plus" small onPress={add} disabled={!text.trim()} />
          </View>
        </Card>
        {state.notes.length === 0 ? (
          <EmptyState icon="note" title={tr("noNotes")} />
        ) : (
          state.notes.map((n) => (
            <Card key={n.id} style={{ marginBottom: 10 }}>
              <View row style={{ justifyContent: "space-between", alignItems: "flex-start", gap: 12 }}>
                <View style={{ flex: 1 }}>
                  <Text style={{ fontWeight: fonts.medium, fontSize: 14, lineHeight: "21px", color: colors.onSurface }}>{n.text}</Text>
                  <Text style={{ fontWeight: fonts.regular, fontSize: 11, color: colors.muted, marginTop: 6 }}>{new Date(n.at).toLocaleString(lang === "de" ? "de-CH" : "en-GB")}</Text>
                </View>
                <Press testID={`note-del-${n.id}`} onClick={() => deleteNote(n.id)}><Icon name="trash" size={18} color={colors.error} /></Press>
              </View>
            </Card>
          ))
        )}
      </View>
    </View>
  );
}
